import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import bannerImg from '../../assets/banner/1.png';
import doctorImg from '../../assets/banner/doctor.png';
import icon from '../../assets/banner/icons/Calling.png';
import shapeFour from '../../assets/banner/pattern.png';
import bannerPattern from '../../assets/banner/pattern_02.png';
import shapeOne from '../../assets/banner/vector_01.png';
import shapeTwo from '../../assets/banner/vector_02.png';
import shapeThree from '../../assets/banner/vector_03.png';
import { trackBookAppointmentClicked, trackCallNowClicked } from '../../utils/analytics';
import { getTenantBranding } from '../../api/api';
import './Banner.scss';

const Banner = () => {
    const [tenantInfo, setTenantInfo] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchTenantInfo = async () => {
            try {
                const brandingData = await getTenantBranding();
                console.log(brandingData);
                setTenantInfo(brandingData);
            } catch (error) {
                console.error('Error fetching tenant info:', error);
            } finally {
                setLoading(false);
            }
        };

        fetchTenantInfo();
    }, []);

    // Handle phone numbers - support both single number (string) and multiple numbers (array)
    const phoneNumbers = tenantInfo?.phone_number 
      ? Array.isArray(tenantInfo.phone_number) 
        ? tenantInfo.phone_number 
        : [tenantInfo.phone_number]
      : ['03 482 394 123'];
    
    // Use the first phone number for the call link (or default)
    const primaryPhoneNumber = phoneNumbers[0];
    const callPhoneNumber = `tel:${primaryPhoneNumber.replace(/\D/g, '')}`;

    return (
      <section className="section-bg section-common banner-section">
        <div className="d-table">
          <div className="d-table-cell">
            <div className="container">
              <div className="row">
                <div className="col-lg-6">
                  <div
                    className="banner-text"
                    data-aos="fade-up"
                    data-aos-duration="2000"
                  >
                    <h1>{tenantInfo?.tagline || 'Entrust your smile to professionals'}</h1>
                    <p>
                      {tenantInfo?.name ? `${tenantInfo.name} - Your smile is our priority! We provide expert dental care with precision, compassion, and the latest advancements in dentistry.` : 'Your smile is our priority! We provide expert dental care with precision, compassion, and the latest advancements in dentistry.'}
                    </p>
                    <div className="banner-bottom">
                      <div className="theme-btn">
                        <Link 
                          to="/contact"
                          onClick={() => {
                            trackBookAppointmentClicked('Banner');
                          }}
                        >
                          Book an appointment
                        </Link>
                      </div>

                      <div className="banner-call">
                        <div className="icon">
                          <img src={icon} alt="icon" />
                        </div>
                        <div className="call-text">
                          <p>Dental 24H Emergency</p>
                          <h6>
                            {phoneNumbers.length > 1 ? (
                              <>
                                {phoneNumbers[0]} <br />
                                {phoneNumbers[1]}
                              </>
                            ) : (
                              phoneNumbers[0]
                            )}
                          </h6>
                        </div>
                        <button 
                          className="call-now-btn"
                          onClick={() => {
                            trackCallNowClicked();
                            window.location.href = callPhoneNumber;
                          }}
                        >
                          Call Now
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-lg-6">
                  <div
                    className="banner-img-area"
                    data-aos="fade-up"
                    data-aos-duration="2000"
                    data-aos-delay="500"
                  >
                    <div className="banner-img">
                      <img 
                        src={tenantInfo?.banner_image_url || bannerImg} 
                        alt="banner model" 
                        onError={(e) => {
                          e.target.src = bannerImg;
                        }}
                      />
                    </div>
                    <div className="info-box">
                      <div className="info-img">
                        <img 
                          src={tenantInfo?.doctor_image_url || doctorImg} 
                          alt="doctor" 
                          onError={(e) => {
                            e.target.src = doctorImg;
                          }}
                        />
                      </div>
                      <div className="info-text">
                        <p>{tenantInfo?.owner_name || 'Dr. Samantha Alice'}</p>
                        <p>
                          <small>{tenantInfo?.tagline || 'Consultant'}</small>
                        </p>
                      </div>
                    </div>

                    {/* Vector Shapes */}
                    <div className="shapes">
                      <img src={shapeOne} alt="shape" />
                      <img src={shapeTwo} alt="shape" />
                      <img src={shapeThree} alt="shape" />
                      <img src={shapeFour} alt="shape" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Banner Pattern Vector*/}
        <img
          className="banner-pattern"
          src={bannerPattern}
          alt="banner pattern"
        />
      </section>
    );
};

export default Banner;